import { render } from "./PaginationTwo.vue?vue&type=template&id=a14b7b00&scoped=true&ts=true"
import script from "./PaginationTwo.vue?vue&type=script&lang=ts"
export * from "./PaginationTwo.vue?vue&type=script&lang=ts"

import "./PaginationTwo.vue?vue&type=style&index=0&id=a14b7b00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14b7b00"]])

export default __exports__